const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgEstado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b333eeb0-140e-4ce4-88c2-b26748f00d68",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f310734e-1f68-40d2-b971-3a8b6d7b7967{fill:#db002c;}.afd5bf86-5c65-4694-b058-6d9291a15c96{fill:#fff;}.f2b68594-ed90-499d-bc91-2d85a7f131e1{fill:#ee8001;}.b1070283-8fc7-43b5-bfb0-9feb408eac56{fill:#ee8002;}.b8d7af44-d96f-4a72-8e0d-f71924671672{fill:#0155a3;}")), /*#__PURE__*/React.createElement("path", {
    className: "f310734e-1f68-40d2-b971-3a8b6d7b7967",
    d: "M5,0H47a5,5,0,0,1,5,5V26.13a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "afd5bf86-5c65-4694-b058-6d9291a15c96",
    d: "M0,26.13l8.93-3.85C12,21,15,19.65,18,18.35a.77.77,0,0,0,.56-.85c0-1.62,0-3.24,0-4.86,0-.37.09-.54.47-.6a24.25,24.25,0,0,0,13.86-7.6c.19-.19.32-.47.61-.55V9.61q0,16.85,0,33.7l-7,0-7.88,0c0-2.49,0-5,0-7.48,0-.57-.13-.59-.6-.38-3.18,1.42-6.38,2.81-9.56,4.21C5.76,40.85,2.69,42.15,0,43.34c0-2.07,0-3.85,0-5.74.24,0,12.08-5.23,17.81-7.74a1.89,1.89,0,0,1,.79-.26v5.59l5.68-2.48c.27-.12.25-.33.25-.55,0-1.56,0-3.12,0-4.69,0-.52-.16-.51-.55-.33-1.14.52-2.3,1-3.45,1.52l-2,.84V23.86l-.46.18L12.07,26.7,0,32C0,30,0,28.07,0,26.13Zm24.51-7.71c0-.83,0-1.67,0-2.5,0-.33-.09-.37-.39-.24L18.9,18a.47.47,0,0,0-.31.51c0,1.62,0,3.24,0,4.87,0,.39.1.45.45.29,1.7-.76,3.41-1.5,5.13-2.24a.5.5,0,0,0,.35-.55C24.5,20,24.51,19.23,24.51,18.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f2b68594-ed90-499d-bc91-2d85a7f131e1",
    d: "M33.5,43.31q0-16.85,0-33.7V3.89c1.56,1.12,3,2.39,4.49,3.6,3.46,2.8,6.9,5.63,10.36,8.45,1.2,1,2.42,2,3.63,2.93a3,3,0,0,1,0,.31c0,7.31,0,20.54,0,24.16H37.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1070283-8fc7-43b5-bfb0-9feb408eac56",
    d: "M0,32,12.07,26.7,18.13,24l.46-.18V29.5l2-.84c1.15-.5,2.31-1,3.45-1.52.39-.18.56-.19.55.33,0,1.57,0,3.13,0,4.69,0,.22,0,.43-.25.55l-5.68,2.48V29.6a1.89,1.89,0,0,0-.79.26C12.09,32.37.25,37.63,0,37.6,0,35.72,0,33.85,0,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1070283-8fc7-43b5-bfb0-9feb408eac56",
    d: "M18.59,43.31l-4.5,0H0s5.76-2.49,8.45-3.68c3.18-1.4,6.38-2.79,9.56-4.21.47-.21.61-.19.6.38C18.58,38.32,18.6,40.82,18.59,43.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1070283-8fc7-43b5-bfb0-9feb408eac56",
    d: "M24.51,18.42c0,.81,0,1.62,0,2.43a.5.5,0,0,1-.35.55c-1.72.74-3.43,1.48-5.13,2.24-.35.16-.45.1-.45-.29,0-1.63,0-3.25,0-4.87A.47.47,0,0,1,18.9,18l5.23-2.29c.3-.13.39-.09.39.24C24.51,16.75,24.51,17.59,24.51,18.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b8d7af44-d96f-4a72-8e0d-f71924671672",
    d: "M5,43.34H47a5,5,0,0,1,5,5V52a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V48.34A5,5,0,0,1,5,43.34Z",
    transform: "translate(52 95.34) rotate(180)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstado);
export default __webpack_public_path__ + "static/media/ESTADO.3ef4d0c40e0dba0f4a499db77c77062c.svg";
export { ForwardRef as ReactComponent };